import {Link, NavLink, useNavigate} from 'react-router-dom';
import {getUser, hasRole} from './api';

// Barra laterale con logo, menu e utente; il menu compare solo se loggati.
export default function Layout({children}) {
    const user = getUser();

    return (
        <div className="d-flex min-vh-100">
            <nav className="sidebar d-flex flex-column p-3">
                <Link to="/" className="mb-4 px-2">
                    <img className="logo" src="/logo1908.svg" alt="Noberasco 1908"/>
                </Link>

                {user && (
                    <>
                        <ul className="nav flex-column mb-auto">
                            <MenuItem to="/" icon="bi-house">Home</MenuItem>
                            <MenuItem to="/bolle-viaggianti" icon="bi-truck">Bolle</MenuItem>
                            {hasRole('ROLE_ADMIN') && (
                                <>
                                    <Sezione>E-commerce</Sezione>
                                    <MenuItem to="/ordini" icon="bi-cart3">Ordini</MenuItem>
                                    <MenuItem to="/clienti" icon="bi-people">Clienti</MenuItem>
                                    <MenuItem to="/fatture" icon="bi-receipt">Fatture</MenuItem>
                                    <Sezione>Admin</Sezione>
                                    <MenuItem to="/avvisi" icon="bi-exclamation-triangle">Avvisi</MenuItem>
                                    <MenuItem to="/amministrazione" icon="bi-gear">Amministrazione</MenuItem>
                                </>
                            )}
                        </ul>

                        <div className="utente">
                            <div className="text-white fw-semibold">{user.googleUserInfo.name}</div>
                            <div className="text-white-50 text-truncate">{user.googleUserInfo.email}</div>
                            <Link to="/logout" className="nav-link mt-2">
                                <i className="bi-box-arrow-right"></i>
                                <span>Esci</span>
                            </Link>
                        </div>
                    </>
                )}
            </nav>

            <main className="flex-grow-1 p-3 p-md-4">{children}</main>
        </div>
    );
}

// Separatore tra gruppi di voci, con il nome del gruppo.
function Sezione({children}) {
    return <li className="nav-sezione">{children}</li>;
}

function MenuItem({to, icon, children}) {
    return (
        <li className="nav-item">
            <NavLink to={to} className="nav-link" end={to === '/'}>
                <i className={icon}></i>
                <span>{children}</span>
            </NavLink>
        </li>
    );
}

// Titolo di pagina, con pulsante "indietro" opzionale.
export function Titolo({children, indietro}) {
    const navigate = useNavigate();
    return (
        <div className="d-flex align-items-center gap-3 mb-4">
            {indietro && (
                <button type="button" className="btn btn-outline-secondary btn-sm" onClick={() => navigate(-1)}
                        title="Indietro">
                    <i className="bi-arrow-left"></i>
                </button>
            )}
            <h1 className="titolo-pagina mb-0">{children}</h1>
        </div>
    );
}

export function Caricamento() {
    return (
        <div className="text-secondary py-3">
            <span className="spinner-border spinner-border-sm me-2" role="status"></span>Caricamento...
        </div>
    );
}

export function Vuoto({children}) {
    return <p className="text-secondary py-3 mb-0">{children}</p>;
}
